export default __webpack_public_path__ + "static/media/wifi_amazing_signal.4573e1dd.svg";